<template>
  <div v-if="coupon.socialSharingAllowed" class="text-center">
    <a target="_top" class="facebook inline-block mr-1">
      <div id="fb-root"></div>
      <div class="fb-like" v-bind:data-href="facebookUrl()" data-width="70" data-layout="button_count" data-show-faces="true" data-send="false"></div>
    </a>
    <a @click="twitterUrl()" title="Twitter" class="tweeter inline-block mx-1">
			<img src="/img/common/twitter.png" alt="Twitter" /> 
		</a>
    <a class="system-link email share-email" @click="openEmailSharingModal()" title="Send Email"> <img src="/img/common/email2.png" alt="Send Email" /> </a>
  </div>
</template>

<script>

import EmailSharingModal from './EmailSharingModal'

export default {
  name: 'SocialSharing',
  props: {
    coupon:{
      type: Object
    },
    location:{
      type: String
    }
  },
  components: {
    EmailSharingModal: 'email-sharing-modal'
  },
  data () {
    return {
      //Not all of these are in use yet, just copied over the full list of possible messaging for use in the future.
      twitterBase: "https://twitter.com/intent/tweet?",
      pinterestBase: "https://pinterest.com/pin/create/button/?",
      pdpHashTag: "ShopHEB",
      recipeHashTag: "HEBrecipe",
      couponHashTag: "HEBsave",
      pdpMessage: "I wanted to share this product with you from",
      recipeMessage: "I found this recipe",
      articleMessage: "I found this artilce",
      videoMessage: "I found this video",
      couponMessage: "See how much I'm saving",
      twitterVia: "HEB",
    }
  },
  methods: {
      initFacebook(){
        //If FB object already loaded, don't load again if there are multiple social-sharing instances on the page.
        if (typeof FB === 'object') {
          //If Social icons are loaded on a page before CDM is clicked, the CDM like button needs to be re-initialized as the initial FB load couldn't see these elements.
          if (this.location === 'CDM') {
            FB.XFBML.parse(document.getElementById('CDM-Container'));
          }
        }else{
          window.fbAsyncInit = function() {
              // init the FB JS SDK
              FB.init({
                  appId : '285140601635770', // App ID from the app dashboard
                  status : true, // Check Facebook Login status
                  xfbml : true,
                  version : 'v3.2'
              });

              // Additional initialization code such as adding Event Listeners goes here
          };
          // function for facebook like
          (function(d, s, id){
              var js, fjs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) {return;}
              js = d.createElement(s); js.id = id;
              js.src = "https://connect.facebook.net/en_US/sdk.js";
              fjs.parentNode.insertBefore(js, fjs);
          }(document, 'script', 'facebook-jssdk'));
        }
      },
      //Creates twitter link and pops up the window for the tweet. Built this way to be able to extend this to replace the social links across the site;
      twitterUrl() {
        var tempUrl = this.twitterBase + encodeURI("original_referer=" + this.locationUrl + "&text=" + this.couponMessage + " @" + this.twitterVia + " &tw_p=tweetbutton&url=" + this.locationUrl + "&hashtags=" + this.couponHashTag);
        window.open(tempUrl, "twitter", "width=655,height=300")
      },
      //Returns the appropriate link for the facebook sharing button. Built this way to be able to extend this to replace the social links across the site;
      facebookUrl() {
        return this.locationUrl;
      },
      openEmailSharingModal(){
        if(this.$route){
          // from inside of the CDM inside of a spa page most likely
          this.hupOpenModal({modalId: 'email-sharing', coupon: this.coupon, closeAction: 'back'})
        }else{
          //for doing this from the PDP/CPL, or the CDM on a non-spa page

          if (this.location === 'CDM') {
            //If on the CDM, give it a back action so it returns to the CDM
            VueStore.$store.commit('profile/OPEN_MODAL', {
              id: 'email-sharing',  
              options: {coupon: this.coupon, closeAction: 'back'}
            })
          } else {
            //On a page like the PDP or CPL, so no need to return anywhere.
            VueStore.$store.commit('profile/OPEN_MODAL', {
              id: 'email-sharing',  
              options: {coupon: this.coupon}
            })
          }
          
        }
      }
  }, 
  mounted: function () {
    this.initFacebook()
  },
  computed: {
      //Recreates the full url of the coupon detail modal for this coupon to hand off to facebook or twitter for sharing. Has to be done manually to avoid bringing closeaction parameter along AND to avoid linking to the cart.
      locationUrl() {
        switch (this.location) {
          case 'CDM':
            return window.location.origin + '/digital-coupon/coupon-detail/' + this.coupon.couponId
          case 'CPL':
            return window.location.origin + '/search/coupon-detail/?q=' + this.coupon.couponId
          default:
            return window.location.origin
        }
      }
  }
}
</script>

<style lang="scss">
@import "../../assets/lib";

</style>

<docs>
This is a vue component for replacing the social sharing icons that appear throughout the site.

When adding new locations, you have to be sure to also add appropriate props to be able to pass to the email sharing modal.
</docs>
